export const environment = {
  production: true,
  apiUrl: 'api/', // Change this to your production API URL when deploying
  googleMapsApiKey: "AIzaSyAP6dnzC-r7_grLk40d8ahVveeqxoMGwD8",
};
